module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var groupTitle = function (subGroup) {
    var group = groups.find(function (g) {
            return g.value === groupBy;
        }) || {};

    return subGroup ? group.subGroupTitle : group.groupTitle;
};

var toHectare = function (value) {
    if (value == null || value === '') {
        return '';
    }

    return numFormat(_.round(value / 10000000, 2));
};

var numFormat = function (num) {
    num = num? num + '' : '';
    return num.replace('.',',');
}
var col = 'D';

    ; __append("\n\n<div class=\"wh100\">\n\n\n\n    <style>\n        .width-regulator td:nth-child(1) {\n            width : 11%;\n        }\n\n        /*.width-regulator td:nth-child(2) {*/\n            /*width : 4%;*/\n        /*}*/\n\n        .width-regulator thead td,\n		.width-regulator td {\n            word-wrap:break-word;\n        }\n    </style>\n\n    <table class=\"w100 gl-report__table width-regulator\">\n        <thead>\n			<tr>\n				<td>")
    ; __append(escapeFn( groupTitle() ))
    ; __append("</td>\n\n				<!--<td>Получено границ полей, тыс.га</td>-->\n				<td>Паспортизировано, тыс.га</td>\n\n				<td>Площадь пашни, тыс.га</td>\n				<td>Паспортизировано, %</td>\n				<!--<td>Получено границ полей, %</td>-->\n			</tr>\n        </thead>\n    </table>\n\n    <div class=\"wh100\">\n        <div class=\"cell__abs_container\">\n            <div class=\"cell__abs overflow-y__auto\">\n                <table class=\"w100 gl-striped__table gl-report__table width-regulator\">\n                    <tbody>\n\n                    ")
    ;  let index = 2;
					data.rows.forEach(function (row) { 
    ; __append("\n						<tr>\n							<td>")
    ; __append(escapeFn( row.group_name ))
    ; __append("</td>\n\n							<!--<td>")
    ; __append(escapeFn( toHectare(row.spatial_area) ))
    ; __append("</td>-->\n							<td>")
    ; __append(escapeFn( toHectare(row.pasport_area) ))
    ; __append("</td>\n\n							<td>")
    ; __append(escapeFn(row.pashnya_ga))
    ; __append("</td>\n							<td>")
    ; __append(escapeFn(row.pasportization_persent))
    ; __append("</td>\n							<!--<td>=ОКРУГЛ(B")
    ; __append(escapeFn(index))
    ; __append("/C")
    ; __append(escapeFn(index))
    ; __append("*100;0)</td>-->\n							<!--<td>=ОКРУГЛ(B")
    ; __append(escapeFn(index))
    ; __append("/D")
    ; __append(escapeFn(index))
    ; __append("*100;0)</td>-->\n						</tr>\n                    ")
    ;  index++; }) 
    ; __append("\n\n						<tr>\n							<th>")
    ; __append(escapeFn( data.total.group_name ))
    ; __append("</th>\n							<!--<th>")
    ; __append(escapeFn( toHectare(data.total.spatial_area) ))
    ; __append("</th>-->\n							<th>")
    ; __append(escapeFn( toHectare(data.total.pasport_area) ))
    ; __append("</th>\n\n							<th>")
    ; __append(escapeFn( data.total.pashnya_ga ))
    ; __append("</th>\n							<th>")
    ; __append(escapeFn( data.total.pasportization_persent ))
    ; __append("</th>\n							<!--<th style=\"color: transparent;text-shadow: none;\">=ОКРУГЛ(B")
    ; __append(escapeFn(index))
    ; __append("/C")
    ; __append(escapeFn(index))
    ; __append("*100;0)</th>-->\n							<!--<th>=ОКРУГЛ(B")
    ; __append(escapeFn(index))
    ; __append("/D")
    ; __append(escapeFn(index))
    ; __append("*100;0)</th>-->\n						</tr>\n					<tr><td colspan=\"4\"></td></tr>\n						")
    ;  data.groups.forEach(function (row) { 
    ; __append("\n						<tr>\n							<th>")
    ; __append(escapeFn( row['group_name'] ))
    ; __append("</th><td></td><td></td>\n							<td>")
    ; __append(escapeFn( row['summ'] ))
    ; __append("</td>\n						</tr>\n						")
    ;  }); 
    ; __append("\n					</tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n\n</div>\n")
  }
  return __output.join("");

}